import MeuTeconService from "../../../services/MeuTeconService";
import { observable } from "mobx";
import { sortCaret } from "../../comum/components/Icones";
import { formatarDataCustomHTML } from "../../../utils/formatar";
import { buscaSemResultado } from "../../../utils/mensagens";


export default class MeuTeconStore {

    @observable colunasModal;
    @observable listaNotifTecon;
    @observable listaItensDash;
    @observable listaClientes;
    @observable abaAtiva;
    @observable modalItem;
    @observable modalCategoria;
    @observable modalTipo;
    @observable modalCategoriaId;
    @observable modalTitulo;
    @observable itensModal;
    @observable tableMessage;
    @observable loadingDash;
    @observable loadingClientes;
    @observable loadingNotificacoes;
    @observable loadingModal;
    @observable listaAlertaNotif;
    @observable notificacoesErro;
    @observable dashboardErro;

    constructor() {

        this.listaNotifTecon = [];
        this.listaItensDash = [];
        this.listaClientes = [];
        this.listaClientesData = [];
        this.ClientesSelecionado = { label: "", value: 0 };
        this.colunasModal = [];
        this.itensModal = [];
        this.abaAtiva = "dash";
        this.tableMessage = buscaSemResultado;
        this.notificacoesErro = "";
        this.dashboardErro = "";

        this.modalTitulo = "";
        this.modalCategoria = "";
        this.modalTipo = null;
        this.modalCategoriaId = "";
        this.modalItem = false;

        this.loadingDash = false;
        this.loadingModal = false;
        this.loadingClientes = false;
        this.loadingNotificacoes = false;
        this.listaAlertaNotif = [];

        this.service = new MeuTeconService();

        this.ListarNotificacoes();
        this.ListarDashboard();
        this.ListarEmpresasPorUsuario();
    }

    alertaNotificacoes = () => {
        this.listaAlertaNotif = [];
        this.listaNotifTecon.map(() => {
            this.listaAlertaNotif.push("");
        });
    }

    ListarNotificacoes = () => {
        this.loadingNotificacoes = true;
        this.notificacoesErro = "";
        this.service.Listar().then(response => {
            if (response && response.data) {
                if (response.data.ExceptionMessage) {
                    this.notificacoesErro = buscaSemResultado;
                    this.listaNotifTecon = [];
                } else {
                    this.listaNotifTecon = response.data;
                }

                if (this.listaNotifTecon && this.listaNotifTecon.length > 0) {
                    this.listaNotifTecon.map((dado, x) => {
                        this.validaSelecaoEmail(dado, x);
                    });
                }
            }
        }).catch(err => {
            console.error(err);
            this.notificacoesErro = "Erro ao carregar notificações.";
        }).finally(() => {
            this.alertaNotificacoes();
            this.loadingNotificacoes = false;
        });
    }

    ListarDashboard = (parcId = null, estabId = null) => {
        this.loadingDash = true;
        this.dashboardErro = "";
        this.service.ListarDashboard(parcId, estabId).then(response => {
            if (response && response.data) {
                if (response.data.ExceptionMessage) {
                    this.dashboardErro = buscaSemResultado;
                    this.listaItensDash = [];
                } else {
                    this.listaItensDash = response.data;
                }
            }
        }).catch(err => console.error(err)
        ).finally(() => { this.loadingDash = false });
    }

    ListarEmpresasPorUsuario = () => {
        this.loadingClientes = true;
        this.service.ListarEmpresasPorUsuario().then(response => {
            if (response && response.data) {
                this.listaClientes = response.data;
            }
        }).catch(err => console.error(err)
        ).finally(() => { this.loadingClientes = false });
    }

        Salvar = (dado) => {
        // dado = objeto de notificação (Id, TipoNotificId, Email, Enviar, etc.)
        this.loadingNotificacoes = true;
        this.notificacoesErro = "";

        return this.service.Salvar(dado)
            .then(response => {
                if (!response || !response.data) {
                    this.notificacoesErro = "Não foi possível salvar as notificações.";
                    return;
                }

                const data = response.data;

                // API MeuTecon/Salvar retorna { Sucesso, Mensagem, notificacao }
                if (data.Sucesso === false) {
                    this.notificacoesErro =
                        data.Mensagem || "Ocorreu um erro ao tentar gravar as informações.";
                    return;
                }

                if (data.notificacao) {
                    // Atualiza o item correspondente na lista em memória
                    this.listaNotifTecon = this.listaNotifTecon.map(n =>
                        n.Id === data.notificacao.Id ? data.notificacao : n
                    );
                }
            })
            .catch(err => {
                console.error(err);
                this.notificacoesErro = "Erro ao salvar as notificações.";
            })
            .finally(() => {
                // Revalida as mensagens de alerta abaixo dos cards
                if (this.listaNotifTecon && this.listaNotifTecon.length > 0) {
                    this.listaNotifTecon.forEach((dado, i) =>
                        this.validaSelecaoEmail(dado, i)
                    );
                }
                this.loadingNotificacoes = false;
            });
    }

    mudarAba = (aba) => {
        this.abaAtiva = aba;
    }

    validaSelecaoEmail = (dado, index) => {
        // Garante que o array existe
        if (!this.listaAlertaNotif) {
            this.listaAlertaNotif = [];
        }

        this.listaAlertaNotif[index] = "";

        if (dado.Enviar) {
            if (!dado.PegarEmailUsuarioLogado && !dado.Email) {
                this.listaAlertaNotif[index] =
                    "Para receber as notificações é necessário informar um e-mail.";
            } else {
                this.listaAlertaNotif[index] = "";
            }
        }
    }


    // Chamado pelo botão "Salvar e-mail"
    salvarNotificacao = (id) => {
        const alvo = this.listaNotifTecon.find(d => d.Id === id);
        if (!alvo) return;

        // Só aqui disparamos a chamada pra API
        return this.Salvar(alvo);
    }

    setEnviar = (id, valueAtual) => {
        this.listaNotifTecon.forEach((dado, x) => {
            if (dado.Id === id) {
                // Toggle do Enviar
                dado.Enviar = !valueAtual;

                // Se desligar o Enviar, também desliga o "usar e-mail do cadastro"
                if (!dado.Enviar) {
                    dado.PegarEmailUsuarioLogado = false;
                }
            }
            this.validaSelecaoEmail(dado, x);
        });
    }

    setUsarEmail = (enviar, id, valueAtual) => {
        this.listaNotifTecon.forEach((dado, x) => {
            if (dado.Id === id) {

                // Se o toggle geral estiver desligado, não faz nada
                if (!enviar) {
                    return;
                }

                dado.PegarEmailUsuarioLogado = !valueAtual;

                // Se passou a usar o e-mail do cadastro, pode opcionalmente limpar o campo manual
                if (dado.PegarEmailUsuarioLogado) {
                    dado.Email = "";
                }
            }
            this.validaSelecaoEmail(dado, x);
        });
    }

    setEmail = (id, value) => {
        this.listaNotifTecon.forEach((dado, x) => {
            if (dado.Id === id) {
                dado.Email = value;
            }
            this.validaSelecaoEmail(dado, x);
        });
    }


    filtrar = () => {
        if (this.ClientesSelecionado.value > 0) {
            //Buscando o parcId e estabId
            this.listaClientes.map((clientes, x) => {
                if (clientes.ClibrsId === this.ClientesSelecionado.value) {
                    const parcId = clientes.Parcid;
                    const estabId = clientes.Estabid;
                    this.ListarDashboard(parcId, estabId);
                }
            });
        }
        else {
            this.ListarDashboard();
        }
    }

    setCliente = (event) => {
        if (event)
            this.ClientesSelecionado = event;
        else
            this.ClientesSelecionado = { label: "", value: 0 };
    };

    abrirModalItem = (titulo, categoria, tipo, idCategoria) => {
        this.colunasModal = [];
        this.modalTitulo = titulo;
        this.modalCategoria = categoria;
        this.modalTipo = tipo;
        this.modalCategoriaId = idCategoria;
        this.modalItem = true;
        this.criaColunasModal();
    }

    fecharModalItem = () => {
        this.modalTitulo = "";
        this.modalCategoria = "";
        this.modalTipo = null;
        this.modalCategoriaId = "";
        this.modalItem = false;
    }

    criaColunasModal = () => {
        let colunas = [];
        switch (this.modalTipo) {
            case 1:
                colunas = [
                    { text: 'Container', dataField: 'Cntr', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'BL', dataField: 'Bl', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'CE', dataField: 'Ce', type: "string", headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'Navio', dataField: 'Navio', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'Previsão de Atracação', dataField: 'DtPrevAtracao', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' }, formatter: formatarDataCustomHTML, campoData: true }
                ];
                this.descargasPrevistas();
                break;
            case 2:
                colunas = [
                    { text: 'Container', dataField: 'Cntr', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'Modalidade', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' }, dataField: 'Modalidade', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'Navio', dataField: 'Navio', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'Data de Chegada', dataField: 'DtEntrada', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' }, formatter: formatarDataCustomHTML, campoData: true },
                    { text: 'Dias no Pátio', dataField: 'DiasPatio', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } }
                ];
                this.containersPatio();
                break;
            case 3:
                colunas = [
                    { text: 'Container', dataField: 'Cntr', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'Tipo', dataField: 'Tipo', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'Modalidade', dataField: 'Modalidade', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'Placa', dataField: 'PlacaCavalo', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'Data de agendamento', dataField: 'DatAgend', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' }, formatter: formatarDataCustomHTML, campoData: true }
                ];
                this.agendamentoCntrPrev();
                break;
            case 4:
                colunas = [
                    { text: 'Container', dataField: 'Cntr', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'Serviço', dataField: 'DscTipoServ', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'Placa', dataField: 'PlacaCavalo', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'Data de solicitação', dataField: 'DatAgend', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' }, formatter: formatarDataCustomHTML, campoData: true }
                ];
                this.agendamentoServPrev();
                break;
            case 5:
                colunas = [
                    { text: 'Número da nota', dataField: 'NumeroNota', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'BL/DUE', dataField: 'Bl', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'Valor', dataField: 'ValorTotal', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' } },
                    { text: 'Data de emissão', dataField: 'DtEmissao', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' }, formatter: formatarDataCustomHTML, campoData: true },
                    { text: 'Data de vencimento', dataField: 'DtVencimento', headerStyle: { position: 'sticky', top: 0, backgroundColor: 'white' }, formatter: formatarDataCustomHTML, campoData: true }
                ];
                this.faturasVencer();
                break;
            default:
                null;
        }
        this.colunasModal = colunas.map(coluna => ({
            sort: true,
            sortCaret: sortCaret,
            headerAlign: 'left',
            align: 'left',
            ...coluna
        }));
    }

    descargasPrevistas = () => {
        this.loadingModal = true;
        this.service.ListarDescargasPrevistas(this.modalCategoriaId).then(response => {
            if (response && response.data) {
                this.itensModal = response.data;
                if (response.data.length === 0) this.tableMessage = buscaSemResultado;
            }
        }).catch(err => console.error(err)
        ).finally(() => { this.loadingModal = false });
    }

    containersPatio = () => {
        this.loadingModal = true;
        this.service.ListarContainerPatio(this.modalCategoriaId).then(response => {
            if (response && response.data) {
                this.itensModal = response.data;
                if (response.data.length === 0) this.tableMessage = buscaSemResultado;
            }
        }).catch(err => console.error(err)
        ).finally(() => { this.loadingModal = false });
    }

    agendamentoCntrPrev = () => {
        this.loadingModal = true;
        this.service.ListarAgendamentosPrevistos(this.modalCategoriaId).then(response => {
            if (response && response.data) {
                this.itensModal = response.data;
                if (response.data.length === 0) this.tableMessage = buscaSemResultado;
            }
        }).catch(err => console.error(err)
        ).finally(() => { this.loadingModal = false });
    }

    agendamentoServPrev = () => {
        this.loadingModal = true;
        this.service.ListarAgendamentoServicoPrevistos(this.modalCategoriaId).then(response => {
            if (response && response.data) {
                this.itensModal = response.data;
                if (response.data.length === 0) this.tableMessage = buscaSemResultado;
            }
        }).catch(err => console.error(err)
        ).finally(() => { this.loadingModal = false; });
    }

    faturasVencer = () => {
        this.loadingModal = true;
        this.service.ListarFaturas(this.modalCategoriaId).then(response => {
            if (response && response.data) {
                this.itensModal = response.data;
                if (response.data.length === 0) this.tableMessage = buscaSemResultado;
            }
        }).catch(err => console.error(err)
        ).finally(() => { this.loadingModal = false });
    }
}

/**
 * [
 *  {
 *    "Id": 0,
 *    "TipoNotificId": 0,
 *    "TipoNotificDesc": "string",
 *    "Email": "string",
 *    "PegarEmailUsuarioLogado": true,
 *    "Enviar": true
 *  }
 * ]
 */




// WEBPACK FOOTER //
// ./src/modules/meutecon/stores/MeuTeconStore.js